module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qKXzxL/tc-custom/9781460301296.jpg?1741121546238",
      "alt": "This image is the cover for the book Narrow Escape, The Sonoma Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Narrow Escape, The Sonoma Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Arissa Tiong and her three-year-old niece are snatched off the street by members of a notorious drug gang. Having lost her police officer brother to a drug bust gone bad, Arissa knows the danger she's in. But she has no idea why they want her. Desperate to protect the little girl, Arissa escapes and runs straight to Nathan Fischer. She knows the handsome, weary former narcotics cop hasn't told her everything about the night that ended her brother's life and Nathan's career. But he's all that stands between her and dangerous thugs who are after something she doesn't even know she has."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Camy Tang\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Camy Tang writes romance with a kick of wasabi. She used to be a biologist, but now she is a staff worker for her church youth group and leads a worship team for Sunday service. On her blog, she ponders frivolous things like knitting, dumb dogs (namely, hers), coffee-geek husbands, the writing journey, Asiana, and anything else that comes to mind. And on her Facebook page, the silliness is unleashed. Join her online!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0